// extracted by mini-css-extract-plugin
module.exports = {"root":"Awards_root__jOtNv","content":"Awards_content__1qvyR","title":"Awards_title__1XDjq","award":"Awards_award__sVb88"};